export enum MoveInEndpoints {
    PostMoveInBooking = '/v1/move-in/book',
}
